import React, { useState } from 'react';
 import { ChevronDown } from "lucide-react";

const faqData = [
  {
    question: "What is NAION?",
    answer:
      "Non-Arteritic Anterior Ischemic Optic Neuropathy (NAION) is a condition caused by reduced blood flow to the optic nerve and can lead to sudden vision loss.",
  },
  {
    question: "Which drugs are involved in these lawsuits?",
    answer:
      "Legal investigations involve GLP-1 medications such as Ozempic, Wegovy, Rybelsus, Trulicity, Mounjaro, and Zepbound.",
  },
  {
    question: "Do I need proof of the medication I used?",
    answer:
      "Knowing the medication you used can help attorneys evaluate your claim, but a case review can begin even if you do not have all records immediately.",
  },
  {
    question: "Do I need medical records to start?",
    answer:
      "Medical records are usually required later, but you can begin by submitting your information for a legal review.",
  },
  {
    question: "How much does it cost to file a lawsuit?",
    answer:
      "Most mass-tort attorneys work on a contingency basis, meaning there are typically no upfront legal fees.",
  },
];



const HomeEight = () => {
  const [activeIndex, setActiveIndex] = useState(null); // No dropdown open by default

  const toggle = (idx) => {
    setActiveIndex(idx === activeIndex ? null : idx);
  };

  return (
    <section className="py-12 px-2 sm:px-4 md:px-8 lg:px-16 w-full max-w-none" style={{ fontFamily: 'Quicksand, sans-serif' }}>
      {/* Title */}
      <h2
        className="text-[32px] sm:text-[40px] font-semibold text-[#0A1F8F] mb-6 capitalize leading-none"
      >
        Frequently Asked{' '}
        <span className="text-[#EDC14A] font-semibold capitalize">
          Questions
        </span>
      </h2>

      {/* Accordion */}
      <div className="space-y-4">
        {faqData.map((item, idx) => (
          <div key={idx} className="border border-gray-200 rounded overflow-hidden">
            <button
              onClick={() => toggle(idx)}
              className={`w-full text-left px-4 py-3 flex justify-between items-center ${
                activeIndex === idx ? 'bg-[#F4F6FC]' : 'bg-white'
              } transition`}
              style={{ fontFamily: 'Quicksand, sans-serif' }}
            >
              <span className="text-[#0A1F8F] text-[20px] sm:text-[24px] font-semibold leading-normal">
                {item.question}
              </span>
             
<span className="text-[18px] font-light select-none">
                <ChevronDown
                  className={`w-5 h-5 transform transition-transform duration-300 
      ${activeIndex === idx ? "rotate-180 text-[#EDC14A]" : "text-[#0A1F8F]"}`}
                />
              </span>
            </button>
            {activeIndex === idx && (
              <div className="px-4 pb-4 pt-1 text-[#757575] text-[18px] sm:text-[20px] font-medium leading-normal bg-[#F4F6FC]" style={{ fontFamily: 'Quicksand, sans-serif' }}>
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeEight;
